import { Modal } from '@/components/ui/Modal';
import { useEntityApprovalActions } from '@/modules/approvals/hooks/useEntityApprovalActions';
import type { EntityTimelineTarget } from '@/modules/approvals/entityApprovalTimeline.types';

import { EntityApprovalPanel } from './EntityApprovalPanel';

interface Props {
  target: EntityTimelineTarget | null;
  onClose: () => void;
}

export function EntityApprovalTimelineModal({ target, onClose }: Props) {
  const {
    instance,
    isFetched,
    canShow,
  } = useEntityApprovalActions({
    ownerModule: target?.ownerModule ?? '',
    entityType: target?.entityType ?? '',
    entityId: target?.entityId ?? null,
    essScope: target?.essScope,
    allowRequesterView: target?.allowRequesterView,
    subjectEmployeeId: target?.subjectEmployeeId,
    recordStatusCode: target?.recordStatusCode ?? target?.leaveStatusCode,
    leaveStatusCode: target?.leaveStatusCode,
    onActionComplete: () => {
      target?.onActionComplete?.();
      onClose();
    },
  });

  const title =
    target?.title ??
    instance?.requesterEmployeeName ??
    instance?.entityType ??
    'Approval timeline';

  return (
    <Modal open={target != null} onClose={onClose} title={title}>
      {target == null ? null : !isFetched ? (
        <p className="text-sm text-slate-500">Loading approval workflow…</p>
      ) : !canShow || !instance ? (
        <p className="text-sm text-slate-500">Unable to load approval workflow for this record.</p>
      ) : (
        <EntityApprovalPanel
          ownerModule={target.ownerModule}
          entityType={target.entityType}
          entityId={target.entityId}
          essScope={target.essScope ?? false}
          allowRequesterView={target.allowRequesterView ?? true}
          autoEditReturned={target.autoEditReturned ?? false}
          recordStatusCode={target.recordStatusCode ?? target.leaveStatusCode}
          leaveStatusCode={target.leaveStatusCode}
          subjectEmployeeId={target.subjectEmployeeId}
          showActions
          className="border-0 p-0 shadow-none"
          onActionComplete={() => {
            target.onActionComplete?.();
            onClose();
          }}
        />
      )}
    </Modal>
  );
}
